import script from "./TagCreator.vue?vue&type=script&setup=true&lang=js"
export * from "./TagCreator.vue?vue&type=script&setup=true&lang=js"

import "./TagCreator.vue?vue&type=style&index=0&id=4fb16104&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fb16104"]])

export default __exports__